module.exports = __webpack_public_path__ + "img/coaching_2.757d95ec.png";